import React, { useRef, useState, useEffect } from "react";
import "./viewBusiness.css";
import MyYuukke from "../../api/MyYuukke";
import VcardChatBox from "../Calender/ProfileCalendar/VcardChatBox";
import { SOCKET_URL } from "../../chatPanel/src/config/config.js";
import { io } from "socket.io-client";

const ViewBusiness = ({ business, onBack }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [formValues, setFormValues] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
    description: "",
  });
  const [chatBox, setChatBox] = useState(false);
  const [serviceChatDetails, setServiceChatDetails] = useState(null);
  const [serviceProvider, setServiceProvider] = useState(null);


  const socket = useRef();
  socket.current = io(SOCKET_URL, {});

  const stripHtml = (html) => (html ? html.replace(/<[^>]*>?/gm, "") : "");
  const name = business.serviceName || business.userName || "Business Name";
  const description =
    stripHtml(business.description || business.serviceDetails) ||
    "No description available";
  const serviceCategory = business.serviceCategory || "General";
  const isOnline = business.onlineAvailable === "true";

  console.log("Viewing Business:", business);

  // ✅ FETCH SERVICE CHAT DETAILS only if email is in localStorage
  useEffect(() => {
    const serviceChatEmail = localStorage.getItem("Bussiness-Customer");

    if (serviceChatEmail && business?.userId) {
      const payload = {
        email: serviceChatEmail,
        userId: business.userId,
      };

      MyYuukke.getServiceChatDetails(payload)
        .then((response) => {
          if (response.data?.message !== "fail") {
            setServiceChatDetails(response.data.data);

              setServiceProvider({
              userId: business?.userId,
              userName: business?.userName,
            });

          }
        })
        .catch((e) => {
          console.error("❌ Error fetching service chat details:", e);
        });
    }
  }, [business?.userId]); // runs only when userId changes

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      userName: formValues.userName,
      email: formValues.email,
      phoneNumber: formValues.phoneNumber,
      userId: business.userId,
      description: formValues.description,
    };

    try {
      const response = await MyYuukke.saveServiceChatDetails(payload);

      console.log("Chat submission response:", response);

      if (response.data?.status === 1) {
        alert("✅ Chat details submitted successfully!");
        setShowDialog(false);
        setChatBox(true);

        localStorage.setItem(
          "Bussiness-Customer",
          response.data?.email || response.data?.data?.email
        );

        // ✅ also set chat details in state after success
        setServiceChatDetails(response.data?.data || null);
      } else {
        alert("❌ Failed to submit chat details. Please try again.");
      }

      setFormValues({
        userName: "",
        email: "",
        phoneNumber: "",
        description: "",
      });
    } catch (err) {
      console.error("❌ Chat submission failed:", err);
      alert("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="view-business-unique">
      {/* Hero Section */}
      <div className="business-hero">
        <button className="back-icon" onClick={onBack}>
          ←
        </button>
        <div className="hero-content">
          <div className="avatar-ring">
            <div className="avatar-img">
              {business.serviceImage ? (
                <img src={business.serviceImage} alt={name} />
              ) : (
                <span>{name.charAt(0).toUpperCase()}</span>
              )}
            </div>
          </div>
          <h1>{name}</h1>
          <p className="category">{serviceCategory}</p>
          {isOnline && <div className="badge-online">🟢 Available Now</div>}
        </div>
      </div>

      {/* Info */}
      <div className="business-info-card glass">
        <h3>About</h3>
        <p>{description}</p>
      </div>

      {/* Actions */}
      <div className="business-action-area">
        <div className="chat-section glass">
          <h3>Want to talk?</h3>
          <p>
            Connect with <strong>{name.split(" ")[0]}</strong> for more info.
          </p>
          <div className="action-buttons">
            <button className="chat-now-btn" onClick={() => setShowDialog(true)}>
              💬 Start Chat
            </button>
            <button className="view-services-btn">🔍 View Services</button>
          </div>
        </div>
      </div>

      {/* === CHAT DIALOG BOX === */}
      {showDialog && (
        <div className="chat-dialog-overlay" onClick={() => setShowDialog(false)}>
          <div className="chat-dialog" onClick={(e) => e.stopPropagation()}>
            <h2>💬 Chat Request</h2>
            <p>Fill in your details to reach out to {name}</p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="userName"
                placeholder="Your Name"
                value={formValues.userName}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formValues.email}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formValues.phoneNumber}
                onChange={handleChange}
                required
              />
              <textarea
                name="description"
                placeholder="Write your message..."
                value={formValues.description}
                onChange={handleChange}
                required
              />

              <div className="dialog-actions">
                <button type="submit" className="submit-chat">
                  🚀 Send Message
                </button>
                <button
                  type="button"
                  className="cancel-chat"
                  onClick={() => setShowDialog(false)}
                >
                  ✖ Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Chat box */}
      {chatBox && serviceChatDetails && business.userId && (
        <VcardChatBox
          socket={socket}
          serviceProvider={serviceProvider}
          handleChatListBoxClose={() => setChatBox(false)}
          serviceUser={serviceChatDetails}
        />
      )}
    </div>
  );
};

export default ViewBusiness;
